import { Box, Grid, useMediaQuery } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Carousel from 'nuka-carousel';
import React, { useEffect, useState } from 'react';

const useStyles = makeStyles((theme) => ({
  customDatePicker: {
    '& .react-date-picker__calendar': {
      zIndex: 2,
    },
    '& .react-date-picker__wrapper': {
      border: 0,
      borderRadius: '4px',
      padding: '6px 16px',
      backgroundColor: '#F3F5F7',
      textAlign: 'left',
      '&:focus': {
        backgroundColor: theme.palette.KenColors.kenWhite,
      },
      '& input': {
        color: theme.palette.KenColors.grey2,
      },
      '& .react-date-picker__inputGroup__divider': {
        color: theme.palette.KenColors.grey2,
      },
      '& .react-date-picker__button': {
        paddingRight: 0,
      },
    },
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    flexDirection: 'column',
    float: 'right',
    marginRight: "100px",
    backgroundColor: "rgba(255, 255, 255, 0.92)",
    padding: "60px 60px 40px",
    margin: "0px !important",
    height: '100%',
    maxHeight: '100%',
    overflowY: 'auto',
    width: "32vw",
    minWidth: 360,
    boxSizing: 'border-box',
    // centers when there is room, but still scrolls fully when content overflows
    // (justify-content: center would make the overflowing ends unreachable)
    '& > *': {
      marginTop: 'auto',
      marginBottom: 'auto',
    },
    [`@media (max-height: 800px)`]: {
      padding: '24px 24px 32px',
    },
    [theme.breakpoints.down('sm')]: {
      background: `#fff`,
      // marginTop: '8% !important',
      marginRight: "15px",
      width: "100%",
      marginTop: "-50px !important"
    },
  },
  loginContent: {
    [theme.breakpoints.down('sm')]: {
      boxShadow: 'none',
    },
    '& .scrollbar-container': {
      width: '100%',
      maxWidth: '500px',
      padding: '48px 84px',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      [`@media (max-height: 800px)`]: {
        padding: '16px 32px',
      },
      [theme.breakpoints.down('sm')]: {
        paddingLeft: '16px',
        paddingRight: '16px',
        maxWidth: '360px',
      },
    },
  },
  title: {
    margin: () =>
      1 / window.devicePixelRatio !== 1 ? '0 auto 16px auto' : '0 0 16px 0',
  },
  subTitle: {
    margin: () =>
      1 / window.devicePixelRatio !== 1 ? '0 auto 32px auto' : '0 0 32px 0',
  },
  inputFieldLabel: {
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '100%',
    textTransform: 'capitalize',
    color: theme.palette.KenColors.grey2,
  },
  verify: {
    width: '100%',
    height: '48px',
    marginBottom: '40px',
    fontSize: '16px',
    fontWeight: 600,
    backgroundColor: '#e21915',
    fontFamily: 'Poppins, sans-serif',
    transition: 'background-color 0.3s', // Add transition for smooth hover effect
    '&:hover': {
      backgroundColor: '#e21915', // Set hover color to the same as backgroundColor
    },
  },
  signupWith: {
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '100%',
    color: theme.palette.KenColors.neutral100,
  },
  signupWithItem: {
    margin: '0 8px',
    width: '40px',
    height: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    boxShadow:
      '0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    '& img': {
      height: '24px',
      width: '24px',
    },
  },
  phoneContainer: {
    display: 'flex',
    '& .phone-input': {
      fontFamily: 'Poppins,sans-serif',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '14px',
      lineHeight: '100%',
      border: '1px solid #F5F7F8',
      padding: '16px',
      order: 2,
      height: '48px',
      borderRadius: '4px',
      marginLeft: '11px',
      '&::placeholder': {
        fontSize: '16px',
        lineHeight: '100%',
        border: '1px solid #F5F7F8',
        fontFamily: 'Poppins,sans-serif',
      },
    },
    '& .phone-dropdown': {
      position: 'relative',
      order: 1,
      border: '1px solid #F5F7F8',
      // background: '#F3F5F7',
      '&.open': {
        // background: '#F3F5F7',
        '& .selected-flag': {
          // background: '#F3F5F7',
        },
      },
      '& .selected-flag': {
        width: '50px',
        padding: '10px',
        background: '#FFFFFF',
        border: '1px solid #F5F7F8',
        '&:hover': {
          // background: '#F3F5F7',
        },
      },
    },
  },
  // imageContainer: {
  //   display: 'flex',
  //   justifyContent: 'right',
  //   alignItems: 'flex-end',
  //   height: '100%',
  //   width: '50%',
  //   paddingBottom: 24,
  //   backgroundImage: `url(${LoginImage})`,
  //   backgroundPosition: 'center',
  //   backgroundSize: 'cover',
  //   backgroundRepeat: 'no-repeat',
  //   [theme.breakpoints.down('md')]: {
  //     backgroundImage: `url(${MobileLoginBG})`,
  //     display: 'none',
  //   },
  // },
  heading: {
    fontSize: 48,
    fontWeight: 700,
    color: theme.palette.KenColors.kenWhite,
    paddingLeft: '24px',
    textTransform: 'capitalize',
    textAlign: 'left',
    width: '96%',
  },
  subHeading: {
    fontSize: 16,
    fontWeight: 400,
    color: theme.palette.KenColors.kenWhite,
    paddingLeft: 24,
    textAlign: 'left',
    width: '95%',
  },
  circularProgress: {
    position: 'absolute',
    top: '54%',
    left: '75%',
    transform: 'translate(-50%, -50%)',
    [theme.breakpoints.down('sm')]: {
      top: '50%',
      left: '49%',
    },
  },
}));

const AuthLayout = ({ children }) => {
  const classes = useStyles();
  // noSsr: evaluate on first render so the carousel doesn't mount hidden and measure itself at 0 width
  const isMdScreen = useMediaQuery('(min-width: 768px)', { noSsr: true });
  
  const imgData = [
    'https://flameprod.blob.core.windows.net/data/WhatsApp%20Image%202026-09-12%20at%2010.49.52%20AM.jpeg',
    'https://flameprod.blob.core.windows.net/data/WhatsApp%20Image%202026-09-12%20at%2011.19.53%20AM.jpeg',
    'https://flameprod.blob.core.windows.net/data/img137.jpg',
    'https://flameprod.blob.core.windows.net/data/img163.jpg',
    'https://flameprod.blob.core.windows.net/data/vvi-environment-day-photos-2026-3-1.jpg',
    'https://flameprod.blob.core.windows.net/data/vvi-food-fest-1.jpg',
  ];

  const videoUrl = 'https://flameprod.blob.core.windows.net/data/vagdevi-intro-video.mp4';
  const videoSlideIndex = imgData.length;

  const [slideIndex, setSlideIndex] = useState(0);
  const isOnVideoSlide = slideIndex === videoSlideIndex;
  const [videoPlayCount, setVideoPlayCount] = useState(0);

  useEffect(() => {
    if (isOnVideoSlide) {
      setVideoPlayCount((count) => count + 1);
    }
  }, [isOnVideoSlide]);

  return (
    <Box style={{ position: 'fixed', inset: 0, height: '100vh', width: '100%', overflow: 'hidden' }}>
      <Grid container direction="row" style={{ width: '100%', height: '100%' }}>
        {/* explicit inset/width: an absolutely positioned Grid ignores flex-basis, so without these the
            carousel shrink-wraps its slides and can collapse to zero width after in-app navigation (OTP screens) */}
        <Grid container item xs={0} md={12} style={{ display: isMdScreen ? 'block' : 'none', position: 'absolute', inset: 0, width: '100%', height: '100%' }}>
          <Grid item xs={12} style={{ width: '100%', maxWidth: '100%' }}>
            <Carousel
              slideIndex={slideIndex}
              afterSlide={(index) => setSlideIndex(index)}
              autoplay={imgData?.length <= 1 || isOnVideoSlide ? false : true}
              wrapAround={true}
              renderCenterRightControls={({ nextSlide }) => ''}
              renderCenterLeftControls={({ previousSlide }) => ''}
              withoutControls={imgData?.length <= 1 ? true : false}
              style={{
                height: window.innerWidth < 600 ? '50vh' : '100vh',
                width: '100%',
              }} // Set Carousel height and width to 100%
            >
              {imgData?.map((items, index) => {
                return (
                  <img
                    src={items}
                    key={index}
                    style={{
                      height: window.innerWidth < 600 ? '50vh' : '100vh',
                      width: '100%',
                      objectFit: 'cover',
                    }}
                    alt="carousel"
                  />
                );
              })}
              <video
                key={videoPlayCount}
                src={videoUrl}
                autoPlay
                muted
                playsInline
                onEnded={() =>
                  setSlideIndex((videoSlideIndex + 1) % (imgData.length + 1))
                }
                style={{
                  height: window.innerWidth < 600 ? '50vh' : '100vh',
                  width: '100%',
                  objectFit: 'cover',
                }}
              />
            </Carousel>
          </Grid>
        </Grid>
        <Grid item xs={12} md={12} sx={{ zIndex: 1, height: '100%', minHeight: 0 }}>
          <Box className={classes.container}>{children}</Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AuthLayout;
